import applyCaseMiddleware from "axios-case-converter";
import axios, { type AxiosInstance, type CreateAxiosDefaults } from "axios";

export const newAxiosClient = (
  defaults?: CreateAxiosDefaults,
): AxiosInstance => {
  return applyCaseMiddleware(axios.create(defaults));
};
